import {RoundTripFlightMatch} from "../models/RoundTripFlightMatch";

// Date inputs use local calendar dates; ISO conversion would shift them in some timezones.
export const localDate = (date: Date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const dateAfter = (days: number) => {const date = new Date(); date.setDate(date.getDate() + days); return localDate(date);};

export function affordableDestinations(results: RoundTripFlightMatch[], budget: number): RoundTripFlightMatch[] {
  const cheapest = new Map<string, RoundTripFlightMatch>();
  for (const result of results) {
    const trip = result.round_trip_flight;
    if (!trip.inbound_flight || !Number.isFinite(trip.total_price) || trip.total_price > budget) continue;
    const legs = trip.outbound_flights?.length ? trip.outbound_flights : [trip.outbound_flight];
    const destination = legs[legs.length - 1].destination_iata;
    if (!cheapest.has(destination) || trip.total_price < cheapest.get(destination)!.round_trip_flight.total_price) cheapest.set(destination, result);
  }
  return Array.from(cheapest.values());
}

export function pickSurprise(choices: RoundTripFlightMatch[], previous?: RoundTripFlightMatch, random = Math.random): RoundTripFlightMatch | undefined {
  const alternatives = choices.filter(choice => choice !== previous);
  const pool = alternatives.length ? alternatives : choices;
  return pool.length ? pool[Math.min(pool.length - 1, Math.floor(random() * pool.length))] : undefined;
}
